'use strict';

var React = require('react');

var SvgMobileBackArrowMajor = function SvgMobileBackArrowMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 10a.75.75 0 0 1-.75.75h-9.69l2.72 2.72a.75.75 0 0 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 1 1 1.06 1.06l-2.72 2.72h9.69a.75.75 0 0 1 .75.75Z"
  }));
};
SvgMobileBackArrowMajor.displayName = "MobileBackArrowMajor";

exports.SvgMobileBackArrowMajor = SvgMobileBackArrowMajor;
